module.exports = __webpack_public_path__ + "static/media/thumbnail_112-FInal.08fd8303.webp";